"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _custom = _interopRequireDefault(require("./custom"));

var _shared = require("./shared");

var _excluded = ["alt", "imageAlt"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styleProps = (0, _styledSystem.compose)(_styledSystem.layout, _styledSystem.position, _styledSystem.space);

var Image = _styledComponents["default"].img.withConfig({
  shouldForwardProp: _shared.shouldForwardProp
}).withConfig({
  displayName: "image__Image",
  componentId: "sc-9vl5oj-0"
})(["", ";", ";"], styleProps, _custom["default"]);

var propTypes = {
  alt: _propTypes.string,
  // Font size css style system prop
  imageAlt: _propTypes.string
};
var ImagePrimitive = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var alt = _ref.alt,
      _ref$imageAlt = _ref.imageAlt,
      imageAlt = _ref$imageAlt === void 0 ? "" : _ref$imageAlt,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(Image, _extends({
    alt: alt || imageAlt,
    ref: ref
  }, props));
});
ImagePrimitive.propTypes = propTypes;
Image.displayName = "Primitives.Image";
var _default = ImagePrimitive;
exports["default"] = _default;